import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import API_BASE_URL from "../../config";
import AddPopForm from "./AddPopForm";

const EditPopForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPop = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/info-manage/pops/${id}`);
        const json = await res.json();
        if (json.success) {
          setEditData(json.data);
        } else {
          alert("POP not found");
          navigate("/info-manage/pop-list");
        }
      } catch (err) {
        alert("Error connecting to server");
        navigate("/info-manage/pop-list");
      } finally {
        setLoading(false);
      }
    };
    fetchPop();
  }, [id, navigate]);

  if (loading) return (
    <div style={{ textAlign: "center", color: "#94a3b8", marginTop: "20px" }}>
      Loading...
    </div>
  );

  return <AddPopForm editData={editData} />;
};

export default EditPopForm;
